document.addEventListener('DOMContentLoaded', () => {
  const boys_lie_variants = [43949874184355, 43949874217123, 43949770735779, 43949770768547];
  const boys_lie_gift = 43964700295331;

  function isDekstop() {
    var e = window, 
        a = 'inner';
    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    if ( e[ a+'Width' ] >= 768 ) {
      return  true;
    } else {
      return false;
    }
  }

  const cart = Shopify.theme.cart;
  // const mobile_menu = document.querySelector('.js-mobile-menu');
  const cart_drawer = document.querySelector('.js-cart');
  const promo_bar = document.querySelector('.js-promo-msg-bar');
  const promo_bar_ship = document.querySelectorAll('.js-promo-msg-ship');
  
  // const upsell_tags = ['Medium-sized Hoops', 'Large Hoops', 'huggies', 'Earring Sets', 'Earring Studs', 'ear cuff', 'Dainty Necklace', 'Statement Necklace', 'ring', 'bracelets'];
  const upsell_products = document.querySelectorAll('.js-cart-upsell-product');
  var upsell_tags = [];
  
  if (document.querySelector('.js-cart-upsell-tags')) {
    upsell_tags = document.querySelector('.js-cart-upsell-tags').dataset.tags.split(',');
  }

  function rebuildCart(state) {
    window.cartStart = state;
    let items_div = '',
        upsells = document.querySelectorAll('.js-cart-upsell-add-to-bag'),
        upsellsInCart = 0;

    // Make array of upsell variant ids
    if (upsells.length > 0) {
        var upsell_ids = [];
  
        Array.from(upsells).forEach((elem) => {
          upsell_ids.push(parseInt(elem.dataset.upsellId));
        });
  
        document.querySelector('.cart-upsell').classList.add("opacity-100");
    }

    // console.log('rebuildCart state',state);

    if (promo_bar_ship.length > 0) {
      if (state.total_price === 0) {
        // console.log(promo_bar.dataset.goal);
        promo_bar_ship.forEach((elem) => {
          elem.innerHTML = promo_bar.dataset.goal;
        });
      } else if (state.total_price <= promo_bar.dataset.price) {
        let away_from_price = (promo_bar.dataset.price - state.total_price) / 100;
        if ((away_from_price % 1 === 0)) {
          away_from_price.toFixed(2);
        }
        away_from_price = '$' + away_from_price;
        // console.log(promo_bar.dataset.calc.replace('$PRICE', away_from_price));
        promo_bar_ship.forEach((elem) => {
          elem.innerHTML = promo_bar.dataset.calc.replace('$PRICE', away_from_price);
        });
      } else {
        // console.log(promo_bar.dataset.success);
        promo_bar_ship.forEach((elem) => {
          elem.innerHTML = promo_bar.dataset.success;
        });
      }
    }

    var variant_ids = [];

    for (let item of state.items) {
      let properties = '';
      let is_bundle = false;
      let bundle_id = '';
      
      for (const property in item.properties) {
        if (!property.includes('_')) {
          properties += `<div>${property}: ${item.properties[property]}</div>`;
        }
        if (property === '_bundle') {
          is_bundle = true;
          bundle_id = item.properties[property];
          properties += `<div>Piercing Bundle</div>`;
        }
      }

      if (properties.length > 0) {
        properties = `
          <div class='cart-item-text__properties mb-3'>
              ${properties}
          </div>
        `;
      }
      
      variant_ids.push(item.variant_id);

      const og_price = item.total_discount > 0 ? `<span class="opacity-60 line-through">${new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD',}).format(item.price / 100)}</span>` : '';

      let discounts = '';
      for (let i = 0, limit = item.discounts.length; i < limit; i++) {
        discounts += item.discounts[i]?.amount > 0 ? `<div class='block p-2 bg-light-gray text-10px mb-4'>${item.discounts[i].title}</div>` : '';
      }
      
      let display_price = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD',}).format(item.discounted_price / 100);
      if (item.discounted_price == 0) {
        display_price = 'Free';
      }

      let is_gwp = '';
      for (let i = 0, limit = item.discounts.length; i < limit; i++) {
        if (item.discounts[i].amount === item.price) {
          is_gwp = 'hide-quantity-buttons';
        }
      }

      let img = item.image

      if (img) {
        img = img.replace('.jpg', '_200x.jpg')
        img = img.replace('.png', '_200x.png')  
      }

      // If cart upsell is present
      if (upsells.length > 0) {
          // Check for variant ID match
          if (upsell_ids.includes(item.variant_id)) {
            document.querySelector(`.js-cart-upsell-add-to-bag[data-upsell-id="${item.variant_id}"]`).closest('.js-cart-upsell-product').classList.add("cart-upsell-hidden");
            upsellsInCart += 1;
          }

          if (upsellsInCart == upsells.length) {
            document.querySelector('.cart-upsell').classList.add("cart-upsell-hidden");
          }
      }

      let variant_title = '';
      if (item.variant_title) {
        variant_title = item.variant_title;
      }

      if (is_bundle) {
        items_div += `
          <div class='js-cart-item-bundle cart-item cart-item--bundle ${is_gwp}'
            data-bundle-id='${bundle_id}'
            data-key='${item.key}'>
            <div class='cart-item__image-cont'>
              <a href='${item.url}' class='cart-item__image-link'>
                <img src='${img}' class='cart-item__image' />
              </a>
            </div>
            <div class='cart-item__text-cont'>
              <div>
                <div class='cart-item-text__title'>
                  <a class="cart-upsell-text__link" href='${item.url}'>
                    <p>${item.product_title}</p>
                  </a>
                  <p>${variant_title}</p>
                </div>
                <div class='cart-item-text__price'>
                    <div>${display_price} ${og_price}</div>
                </div>
                ${properties}
                ${discounts}
              </div>
              <div class='cart-item-buttons flex justify-between w-full'>
                <div>
                  <span>Qty: ${item.quantity}</span>
                </div>
              </div>
            </div>
          </div>`;
      } else {
        items_div += `
          <div class='cart-item ${is_gwp}'>
            <div class='cart-item__image-cont'>
              <a href='${item.url}' class='cart-item__image-link'>
                <img src='${img}' class='cart-item__image' />
              </a>
            </div>
            <div class='cart-item__text-cont'>
              <div>
                <div class='cart-item-text__title'>
                  <a class="cart-upsell-text__link" href='${item.url}'>
                    <p>${item.product_title}</p>
                  </a>
                  <p>${variant_title}</p>
                </div>
                <div class='cart-item-text__price'>
                    <div>${display_price} ${og_price}</div>
                </div>
                ${properties}
                ${discounts}
              </div>
              <div class='cart-item-buttons flex justify-between w-full'>
                <div class='cart-item-quantity'>
                  <button class='js-minus cart-item-quantity__button cart-item-quantity__button--minus' data-key='${item.key}'>-</button>
                  <span class='cart-item-quantity__count'>${item.quantity}</span>
                  <button class='js-plus cart-item-quantity__button cart-item-quantity__button--plus' data-key='${item.key}'>+</button>
                </div>
                <div>
                  <div class='js-remove cart-item-buttons__remove' data-key='${item.key}'>Remove</div>
                </div>
              </div>
            </div>
          </div>`;
      }
        
    }

    var product_tags;

    if (state.items.length == 0) {
        items_div = `<div class='cart-empty'>
                        Your Cart Is Empty
                    </div>`;
    } else {
      for (let i = 0, limit = state.items.length; i < limit; i++) {
        if (Object.hasOwn(state.items[i], '_tags')) {
          product_tags = state.items[i].properties['_tags'].split(',');
          break;
        }
      }
    }

    // console.log('product_tags',product_tags);
    // console.log('variant_ids',variant_ids);

    var upsell_tag;

    if (product_tags) {
      // console.log(upsell_tags);
      for (let i = 0, limit = upsell_tags.length; i < limit; i++) {
        if (product_tags.includes(upsell_tags[i])) {
          // console.log('the tag is: ', upsell_tags[i]);
          upsell_tag = upsell_tags[i];

        }
      }
  
      let upsell_counter = 0;
  
      for (let i = 0, limit = upsell_products.length; i < limit; i++) {
        let upsell_product = upsell_products[i];
        let upsell_product_tags = upsell_product.dataset.tags.split(',');
        
        let upsell_in_cart = false;
        if (variant_ids.includes(parseInt(upsell_product.querySelector('.js-cart-upsell-add-to-bag').dataset.upsellId))) {
          upsell_in_cart = true;
        }

        if (upsell_product_tags.includes(upsell_tag) && !upsell_in_cart && upsell_counter < 2) {
          upsell_product.classList.remove('cart-upsell-hidden');
          upsell_counter++;
          // console.log('show:', upsell_product.querySelector('.cart-upsell-text__title').textContent, parseInt(upsell_product.querySelector('.js-cart-upsell-add-to-bag').dataset.upsellId));
        } else {
          // console.log('hide:', upsell_product.querySelector('.cart-upsell-text__title').textContent, parseInt(upsell_product.querySelector('.js-cart-upsell-add-to-bag').dataset.upsellId));
          upsell_product.classList.add('cart-upsell-hidden');
        }

      }
    } else {
      upsell_products[0].classList.remove('cart-upsell-hidden');
      upsell_products[1].classList.remove('cart-upsell-hidden');

      for (let i = 2, limit = upsell_products.length; i < limit; i++) {
        upsell_products[i].classList.add('cart-upsell-hidden');
      }
    }

    if (document.querySelectorAll('.js-cart-upsell-product.cart-upsell-hidden').length == upsell_products.length) {
      document.querySelector('.js-cart-upsell').classList.add('cart-upsell-hidden');
    } else {
      document.querySelector('.js-cart-upsell').classList.remove('cart-upsell-hidden');
    }
  
    document.querySelector('.js-items').innerHTML = items_div;

    if (state.total_discount > 0) {
      document.querySelector('.js-cart-discount').classList.remove('hidden');
      document.querySelector('.js-price-discount').innerHTML = '-' + new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD',}).format(state.total_discount / 100);
      document.querySelector('.js-price').innerHTML = `
      <div class="flex justify-end items-center gap-1">
        <span class="opacity-60 line-through">${new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD',}).format(state.original_total_price / 100)}</span>
        <span>${new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD',}).format(state.total_price / 100)}</span>
      </div>
      `;
    } else {
      document.querySelector('.js-cart-discount').classList.add('hidden');
      document.querySelector('.js-price').innerHTML = new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD',}).format(state.total_price / 100);
    }

    document.querySelector('.js-count').innerHTML = state.item_count;
    document.querySelector('.js-count-header').innerHTML = state.item_count;

    // Bundles
    const bundle_items = document.querySelectorAll('.js-cart-item-bundle');
    const bundles = {};
    let bundle_id;
    for (let i = 0, limit = bundle_items.length; i < limit; i++) {
      if (bundle_id === bundle_items[i].dataset.bundleId) {
        bundles[bundle_id].push(bundle_items[i]);
      } else {
        bundle_id = bundle_items[i].dataset.bundleId;
        bundles[bundle_id] = [];
        bundles[bundle_id].push(bundle_items[i]);
      }
    }

    for (const [key, value] of Object.entries(bundles)) {
      bundles[key][0].classList.add('cart-item--bundle-border');
      let remove_keys = {
        "updates": {}
      };
      bundles[key].forEach((item) => {
        remove_keys.updates[item.dataset.key] = 0;
      });
      // console.log('remove_keys',remove_keys);
      let remove_button = document.createElement('DIV');
      remove_button.innerHTML = `
        <div class='js-cart-bundle-remove cart-item-buttons__remove' data-remove='${JSON.stringify(remove_keys)}'>Remove Bundle</div>
      `;
      bundles[key][bundles[key].length - 1].querySelector('.cart-item-buttons').append(remove_button);
    }
  
    // console.log('bundles',bundles);

    const remove_bundles = document.querySelectorAll('.js-cart-bundle-remove');

    remove_bundles.forEach((button) => {
      button.addEventListener('click', (e) => {
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: button.dataset.remove
        })
        .then(response => {
          // console.log('remove response 1',response);
          if(response.ok) {
            return response.json();
          }
        })
        .then(response => {
          // console.log('remove response json',response);
          Shopify.theme.cart.getState().then(state => {
            // console.log('getState',state);
            Shopify.theme.cart.rebuildCart(state);
            Shopify.theme.cart.gwpUpdate(state);
          });
        })
        .catch((error) => {
          console.error('Error:', error);
          alert('One of the items is no longer available, please refresh the page and try making another bundle');
        });
      });
    });

    const minus_elements = document.querySelectorAll('.js-minus');
        
    for (const minus of minus_elements) {
        minus.addEventListener('click', (e) => {
            const key = minus.dataset.key;
            const item = state.items.find(item => item.key === key);

            const quantity = (item.quantity <= 1) ? 0 : (item.quantity - 1);
  
            cart.updateItem(key, { quantity }).then(state => {

              let upsellProduct = document.querySelector(`.js-cart-upsell-add-to-bag[data-upsell-id="${key.slice(0, key.indexOf(':'))}"]`);
  
              // if (upsellProduct && quantity == 0) {
              //     upsellProduct.closest('.js-cart-upsell-product').classList.remove("cart-upsell-hidden");
              //     document.querySelector('.cart-upsell').classList.remove("cart-upsell-hidden");
              // }
  
              rebuildCart(state);
              gwpUpdate(state);

              if (window.location.pathname === '/cart') {
                location.reload();
              }
          });
        })
    }
  
    const plus_elements = document.querySelectorAll('.js-plus')
        
    for (const plus of plus_elements) {
      plus.addEventListener('click', (e) => {
        const key = plus.dataset.key;
        const item = state.items.find(item => item.key === key);
        const quantity = item.quantity + 1;

        cart.updateItem(key, { quantity }).then(state => {
          rebuildCart(state);
          gwpUpdate(state);
          if (window.location.pathname === '/cart') {
            location.reload();
          }
        }).catch((e) => {
          if (e.status == 422) {
            alert('No more inventory available.');
          }
        });
      })
    }
  
    const remove_elements = document.querySelectorAll('.js-remove')
  
    for (const remove of remove_elements) {
      remove.addEventListener('click', (e) => {
          const key = remove.dataset.key;

          cart.removeItem(key).then(state => {

            let upsellProduct = document.querySelector(`.js-cart-upsell-add-to-bag[data-upsell-id="${key.slice(0, key.indexOf(':'))}"]`);

            // if (upsellProduct) {
            //     upsellProduct.closest('.js-cart-upsell-product').classList.remove("cart-upsell-hidden");
            //     document.querySelector('.cart-upsell').classList.remove("cart-upsell-hidden");
            // }

            rebuildCart(state);
            gwpUpdate(state);
            if (window.location.pathname === '/cart') {
              location.reload();
            }
        });
      })
    }

  }

  Shopify.theme.cart.rebuildCart = rebuildCart;

  function gwpUpdate(state) {
    if (document.querySelector('.js-gwp')) {
      const cart_total = state.total_price;
      const gwp_threshold = parseInt(document.querySelector('.js-gwp').dataset.gwpThreshold) * 100;
      const progress_bar = document.querySelector('.js-gwp-progress-bar');
      const spend_more = document.querySelector('.js-gwp-spend-more');
      const gwp_id = parseInt(document.querySelector('.js-gwp').dataset.gwpId);
      const gwp_above = document.querySelector('.js-gwp-above');
      const gwp_below = document.querySelector('.js-gwp-below');
  
      let contains_gwp = false;
      let gwp_key;
      let gwp_price = 0;
      let gwp_discount = false;

      // console.log('gwpUpdate state init', state, gwp_threshold);

      state.items.forEach((item) => {
        if (item.variant_id === gwp_id) {
          contains_gwp = true;
          gwp_key = item.key;
          gwp_price = item.discounted_price;

          
          if (item.discounts.some((discount) => discount.amount === item.price)) {
            gwp_discount = true;
          }
        }
      });
      // let updated_price = (gwp_threshold - state.total_price - gwp_price) / 100;
      // let percentage = ((state.total_price / gwp_threshold) * 100).toFixed(2);

      // if (!gwp_discount) {
      //   updated_price = (gwp_threshold - state.total_price + gwp_price) / 100;
      //   percentage = (((state.total_price - gwp_price) / gwp_threshold) * 100).toFixed(2);
      // }

      if (contains_gwp) {
        // console.log('contains gwp');
        let updated_price = (gwp_threshold - state.total_price + gwp_price) / 100;
        let percentage = (100 - ((updated_price * 100) / gwp_threshold * 100)).toFixed(2);
        // console.log('percentage: ' + percentage,'updated_price: ' + updated_price, gwp_threshold, state.total_price, 'gwp_price: ' + gwp_price);
        updateGwpText(percentage, updated_price);
        if (gwp_discount) {
          gwp_above.classList.remove('hidden');
          gwp_below.classList.add('hidden');
        } else if (cart_total >= gwp_threshold) {
          gwp_above.classList.add('hidden');
          gwp_below.classList.remove('hidden');
        } else if (cart_total < gwp_threshold) {
          gwp_above.classList.add('hidden');
          gwp_below.classList.remove('hidden');
        }
      } else {
        // console.log('does not contain gwp');
        let updated_price = (gwp_threshold - state.total_price) / 100;
        let percentage = (state.total_price / gwp_threshold * 100).toFixed(2);
        // console.log('percentage: ' + percentage,'updated_price: ' + updated_price, gwp_threshold, state.total_price);
        updateGwpText(percentage, updated_price);
        if (cart_total >= gwp_threshold) {
          // console.log('add gwp');
          gwp_above.classList.remove('hidden');
          gwp_below.classList.add('hidden');
          addGWP(gwp_id);
        }
      }

      function updateGwpText(percentage, updated_price) {
        progress_bar.style.background = `linear-gradient(90deg, #355070 0 ${percentage}%, #fff 0 ${100 - percentage}%)`;
        spend_more.textContent = `${new Intl.NumberFormat('en-US', {style: 'currency',currency: 'USD',}).format(updated_price)}`;
      }

      // if (contains_gwp) {
      //   if (cart_total >= gwp_threshold) {
      //     // console.log('add gwp');

      //     if (gwp_discount) {
      //       gwp_above.classList.remove('hidden');
      //       gwp_below.classList.add('hidden');
      //     } else {
      //       gwp_above.classList.add('hidden');
      //       gwp_below.classList.remove('hidden');
      //       console.log('remove gwp');
      //       // removeGWP(gwp_key);
      //     }
      //   } else if (cart_total < gwp_threshold) {
      //     console.log('remove gwp');
      //     gwp_above.classList.add('hidden');
      //     gwp_below.classList.remove('hidden');
      //     removeGWP(gwp_key);
      //   }
      // } else {
      //   if (cart_total >= gwp_threshold) {
      //     console.log('add gwp');
      //     gwp_above.classList.remove('hidden');
      //     gwp_below.classList.add('hidden');
      //     addGWP(gwp_id);
      //   }
      // }

      // if (cart_total >= gwp_threshold) {
      //   console.log('add gwp');
      //   gwp_above.classList.remove('hidden');
      //   gwp_below.classList.add('hidden');

      //   if (!contains_gwp) {
      //     addGWP(gwp_id);
      //   }
      // } else if (cart_total < gwp_threshold) {
      //   console.log('remove gwp');
      //   gwp_above.classList.add('hidden');
      //   gwp_below.classList.remove('hidden');

      //   if (contains_gwp) {
      //     removeGWP(gwp_key);
      //   }
      // }

      function addGWP(gwp_id) {
        let properties = {'_gwp': 'true'};
        cart.addItem(gwp_id, { quantity: 1, properties})
        .then(item => {
          cart.getState().then(state => {
            rebuildCart(state);
            if (window.location.pathname === '/cart') {
              location.reload();
            }
            document.body.classList.add("cart--open", "prevent-scroll");
          });  
        }).catch((e) => {
          if (e.status == 422) {
              alert('Gift With Purchase Unavailable')
          }
        });
      }

      function removeGWP(gwp_key) {
        cart.removeItem(gwp_key)
        .then(item => {
          cart.getState().then(state => {
            rebuildCart(state);
            if (window.location.pathname === '/cart') {
              location.reload();
            }
            document.body.classList.add("cart--open", "prevent-scroll");
          });  
        }).catch((e) => {
          if (e.status == 422) {
              alert('Gift With Purchase Unavailable')
          }
        });
      }
    }
  }

  Shopify.theme.cart.gwpUpdate = gwpUpdate;
  
  if (document.querySelector('.js-cart-add-to-bag')) {
    Array.from(document.querySelectorAll('.js-cart-add-to-bag')).forEach((elem) => {
        elem.addEventListener('click', (e) => {
            cart.addItem(parseInt(elem.dataset.upsellId), 1).then(item => {
              location.reload();
            }).catch((e) => {
                if (e.status == 422) {
                    alert('No more inventory available.')
                }
            })
        });
    });
  }

  function boysLieGwp(state) {
    let cart_ids = state.items.map((item) => item.variant_id );
    let contains_variant = cart_ids.some((id) => {
      return boys_lie_variants.includes(id);
    });
    let contains_gift = cart_ids.includes(boys_lie_gift);

    // console.log('cart_ids', cart_ids, 'contains_variant', contains_variant, 'contains_gift', contains_gift);

    if (contains_variant && !contains_gift) {
      cart.addItem(boys_lie_gift, { quantity: 1 })
      .then(item => {
        cart.getState().then(state => {
          rebuildCart(state);
          if (window.location.pathname === '/cart') {
            location.reload();
          }
          document.body.classList.add("cart--open", "prevent-scroll");
        });  
      }).catch((e) => {
        if (e.status == 422) {
            alert('Gift With Purchase Unavailable')
        }
      });
    } else {
      rebuildCart(state);
      gwpUpdate(state);
    }
  }

  if (document.querySelector('.js-add-to-cart')) {
    document.querySelector('.js-add-to-cart').addEventListener('click', (e) => {
        e.preventDefault();
  
        if (document.getElementById('productTags').value.includes('comingsoon')) {
          alert('This product is not yet available');
        } else {
          const form = document.querySelector('.js-form')
    
          cart.addItemFromForm(form).then(item => {
    
            cart.getState().then(state => {

              // console.log(state);
              
              if (window.luv_aj.boys_lie_gwp) {
                boysLieGwp(state);
              } else {
                rebuildCart(state);
                gwpUpdate(state);
              }
            });

            document.body.classList.add("cart--open", "prevent-scroll");
    
          }).catch((e) => {
              if (e.status == 422) {
                  alert('No more inventory available.')
              }
          })
        }
  
    })
  }

  if (document.querySelector('.js-form')) {
    function preorderButton(mutations) {
      for (let mutation of mutations) {
        // console.log(mutation);
        if (document.getElementById('preorder-me-btn')) {

            document.getElementById('preorder-me-btn').addEventListener('click', (e) => {
                e.preventDefault();
            
                const form = document.querySelector('.js-form')
            
                cart.addItemFromForm(form).then(item => {
            
                    cart.getState().then(state => {
                    rebuildCart(state);
                    gwpUpdate(state);
            
                    });
            
                    document.body.classList.add("cart--open", "prevent-scroll");
            
                }).catch((e) => {
                    if (e.status == 422) {
                        alert('No more inventory available.')
                    }
                })
            
            });
            
            preorderObserver.disconnect();
    
            break

        }
      }            
    }
    
    //Observer for preorder button
    let jsForm = document.querySelector('.js-form');
    let preorderConfig = { attributes: true, subtree: true };
    let preorderObserver = new MutationObserver(preorderButton);
    preorderObserver.observe(jsForm, preorderConfig);
    
    if (document.getElementById('preorder-me-btn')) {
      // console.log(document.getElementById('preorder-me-btn'));
      document.getElementById('preorder-me-btn').addEventListener('click', (e) => {
          e.preventDefault();
      
          const form = document.querySelector('.js-form')
      
          cart.addItemFromForm(form).then(item => {
      
              cart.getState().then(state => {
              rebuildCart(state);
      
              });
      
              document.body.classList.add("cart--open", "prevent-scroll");
      
          }).catch((e) => {
              if (e.status == 422) {
                  alert('No more inventory available.')
              }
          })
      
      })
    }
  }
  
  if (document.querySelector('.js-cart-upsell-add-to-bag')) {
    var upsell_ids = [];
  
    Array.from(document.querySelectorAll('.js-cart-upsell-add-to-bag')).forEach((elem) => {
        upsell_ids.push(parseInt(elem.dataset.upsellId));
    });
  
    cart.getState().then(state => {
        for (let item of state.items) {
            if (upsell_ids.includes(item.variant_id)) {
                document.querySelector(`.js-cart-upsell-add-to-bag[data-upsell-id="${item.variant_id}"]`).closest('.js-cart-upsell-product').classList.add("cart-upsell-hidden");
            }
        }
    })
  
    Array.from(document.querySelectorAll('.js-cart-upsell-variant-selector')).forEach((elem) => {
      elem.addEventListener('change', (e) => {
        let product = elem.closest('.js-cart-upsell-product')
        product.querySelector('.js-cart-upsell-add-to-bag').dataset.upsellId = elem.value;
        product.querySelector('.js-cart-upsell-price').textContent = elem.options[elem.selectedIndex].dataset.price;
      })
    });

    Array.from(document.querySelectorAll('.js-cart-upsell-add-to-bag')).forEach((elem) => {
        elem.addEventListener('click', (e) => {
            let quantity = 1;
            let properties = {
              '_tags': elem.closest('.js-cart-upsell-product').dataset.tags
            };
            cart.addItem(parseInt(elem.dataset.upsellId), { quantity, properties}).then(item => {
  
              cart.getState().then(state => {
                rebuildCart(state);
                gwpUpdate(state);

                if (window.location.pathname === '/cart') {
                  location.reload();
                }
  
            });
                
            }).catch((e) => {
                if (e.status == 422) {
                    alert('No more inventory available.')
                }
            })
        });
    });
  }

  if (document.querySelector('.js-ymal-add-to-bag')) {
    Array.from(document.querySelectorAll('.js-ymal-variant-selector')).forEach((elem) => {
      elem.addEventListener('change', (e) => {
        let product = elem.closest('.js-ymal-product');

        product.querySelector('.js-ymal-add-to-bag').dataset.upsellId = elem.value;
        product.querySelector('.js-ymal-price').textContent = elem.options[elem.selectedIndex].dataset.price;
      })
    });

    Array.from(document.querySelectorAll('.js-ymal-add-to-bag')).forEach((elem) => {
        elem.addEventListener('click', (e) => {

            cart.addItem(parseInt(elem.dataset.upsellId), 1).then(item => {
  
              cart.getState().then(state => {

                if (window.luv_aj.boys_lie_gwp) {
                  boysLieGwp(state);
                } else {
                  rebuildCart(state);
                  gwpUpdate(state);
                }

                if (window.location.pathname === '/cart') {
                  location.reload();
                }
  
                document.body.classList.add("cart--open", "prevent-scroll");
            });
                
            }).catch((e) => {
                if (e.status == 422) {
                    alert('No more inventory available.')
                }
            })
        });
    });
  }
  
  const cart_trigger = document.querySelector('.js-open-cart');

  cart_trigger.addEventListener("click", function (e) {
    e.preventDefault();
    
    document.body.classList.add("cart--open", "prevent-scroll");
    document.body.classList.remove("mobile-menu--open");

    // if (isDekstop()) {

    // } else {
    //   cart_drawer.addEventListener('transitionend', (e) => {
    //     document.body.classList.remove("mobile-menu--open");
    //   }, {once: true});
    // }
    // cart_drawer.addEventListener('transitionend', (e) => {
    //   document.body.classList.remove("mobile-menu--open");
    // }, {once: true});
  
    cart.getState().then(state => {
      rebuildCart(state);
      gwpUpdate(state);
    });
  });
  
  if (document.querySelector(".js-close-cart")) {
    var trigger = document.querySelector(".js-close-cart");
    trigger.addEventListener("click", function (e) {
        e.preventDefault();
        document.body.classList.remove("cart--open", "prevent-scroll");
    });
  }
});